import React from 'react';
import { Home, Tag, BookOpen, Users } from 'lucide-react';
export function IntentLinks() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-52">
      <h2 className="text-2xl font-serif text-brand-dark mb-6 text-center" data-id="element-53">
        How can Marcus help?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-54">
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-55">
          
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-56">
            <Tag size={22} data-id="element-57" />
          </div>
          <div data-id="element-58">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-59">
              Selling a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-60">
              Every path to sell, one agent
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-61">
          
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-62">
            <Home size={22} data-id="element-63" />
          </div>
          <div data-id="element-64">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-65">
              Buying a home
            </p>
            <p className="text-sm text-brand-muted" data-id="element-66">
              Matched by results in your neighborhood
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-67">
          
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-68">
            <BookOpen size={22} data-id="element-69" />
          </div>
          <div data-id="element-70">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-71">
              Marcus Chen on Stan
            </p>
            <p className="text-sm text-brand-muted" data-id="element-72">
              Courses, guides & resources
            </p>
          </div>
        </a>
        <a href="#" className="flex items-center gap-4 p-5 bg-white rounded-2xl border border-brand-light hover:border-brand-forest hover:shadow-premium transition-all group" data-id="element-73">
          
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0 group-hover:bg-brand-forest group-hover:text-white transition-colors" data-id="element-74">
            <Users size={22} data-id="element-75" />
          </div>
          <div data-id="element-76">
            <p className="font-medium text-brand-dark group-hover:text-brand-forest transition-colors" data-id="element-77">
              Join Our Team
            </p>
            <p className="text-sm text-brand-muted" data-id="element-78">
              Interested in joining the Chen Real Estate Group?
            </p>
          </div>
        </a>
      </div>
    </section>;
}